<template>
  <template v-if="itemList.length">
    <div class="user-item">
      <div
        class="info-block flex-column align-center justify-center"
        v-if="index == 0"
      >
        <slideInfo
          title="20000+宝妈真实好评#身边人都说好"
          buttonText="选月嫂"
          align="center"
          buttonType="simple"
          :divider="false"
        />
      </div>

      <EvalDetail
        v-else
        :placement="detailPopperPlacement()"
        :loading="loading"
        :evalDetail="evalDetail"
        @open="detailPopperIndex = index"
        @close="detailPopperIndex = -1"
      >
        <div class="header-block-wrapper">
          <div
            v-for="(item, itemIndex) in itemList"
            :key="item.id"
            :class="[
              'header-block pointer',
              {
                hide: itemIndex == 0,
                show: itemIndex == 1,
              },
            ]"
            :style="{
              transition: `opacity 0.5s ${transitionTime}s ease`,
            }"
          >
            <img
              draggable="false"
              class="header full-parent"
              :src="item.uheader"
              @click="handleShowDetail(true, item)"
            />
            <div
              v-if="detailPopperIndex == index"
              class="
                eval-popping
                full-parent
                flex-column
                align-center
                justify-center
              "
            >
              宝妈点评
            </div>
          </div>
        </div>
      </EvalDetail>
    </div>
  </template>
</template>

<script lang="ts">
import { isInclude, post, PostConfig, randomNumber } from "@/assets/utils/common";
import { api } from "@/assets/utils/config";
import { defineComponent } from "vue";
import mpPopover from "../../../../../components/mp-popover/mp-popover.vue";
import slideInfo from "../../slide-info/slide-info.vue";
import { Toast } from "vant";
import EvalDetail from "../../eval-detail/eval-detail.vue";

export default defineComponent({
  components: {
    mpPopover,
    slideInfo,
    EvalDetail,
  },

  props: {
    data: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      interval: <any>null,
      evalDetail: <any>null,
      loading: <boolean>false,
      detailPopperIndex: <number>-1,
      itemList: <any>[],
      transitionTime: 0,
    };
  },

  watch: {
    'data'(newVal, _oldVal) {
      this.itemList.push(newVal);

      let t = setTimeout(() => {
        if (this.itemList.length >= 3) this.itemList.splice(0, 1);
        clearTimeout(t);
      }, 600);
    }
  },

  mounted() {
    let type = this.index;
    if (this.index <= 7) type = this.index;
    else if (this.index == 8) type = 1;
    else if (this.index == 9) type = 8;
    else if (this.index == 10) type = 2;
    else if (this.index == 11) type = 9;
    else type = this.index - 12 + 4;

    this.transitionTime = 5 / ((18 / type) * 4);

    this.itemList = [this.data];

    this.getItem();
    if (this.index > 0) {
      this.interval = setInterval(() => {
        this.getItem();
      }, 5000);
    }
  },

  unmounted() {
    clearInterval(this.interval);
  },

  methods: {
    getItem() {
      if (this.detailPopperIndex == -1) this.$emit('getItem');
    },

    handleShowDetail(visible: boolean, item?: any) {
      if (visible) {
        let config: PostConfig = {
          url: api.getEvaluateDetail,
          param: { id: item.id },
        };
        this.loading = true;
        post(config).then((res: any) => {
          this.loading = false;
          if (res.status == 0) {
            this.evalDetail = res.data;
          } else {
            Toast.fail(res.msg);
          }
        });
      } else {
        this.evalDetail = null;
      }
    },

    detailPopperPlacement() {
      let index = this.index;
      if (index == 1) return 'bottom-start';
      else if (index == 7) return 'bottom-end';
      else if (isInclude(index, [2, 3, 4, 5, 6])) return 'bottom';
      else if (index == 8) return 'right-start';
      else if (index == 9) return 'left-start';
      else if (index == 10) return 'right';
      else if (index == 11) return 'left';
      else if (index == 12) return 'top-start';
      else if (index == 18) return 'top-end';
      else return 'top';
    },
  },
});
</script>

<style lang="less" scoped>
@userItemSize: 9.43vw;

.user-item {
  position: relative;
  display: inline-grid;

  /deep/.popper {
    z-index: 1;
  }

  &:first-child {
    grid-row-start: 2;
    grid-row-end: 4;
    grid-column-start: 2;
    grid-column-end: 7;
  }

  .header-block-wrapper {
    width: @userItemSize;
    height: @userItemSize;
  }

  .header-block {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;

    &.show {
      opacity: 1;
      pointer-events: auto;
    }

    .header {
      object-fit: cover;
      border: solid rgba(0, 0, 0, 0.1) 1px;
    }

    .eval-popping {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 1.04vw;
      line-height: 1.56vw;
      font-family: @font-ab;
      color: white;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      animation: fadeIn 0.2s ease;
      animation-fill-mode: forwards;
    }
  }
}
</style>
